import script from "./AdministratorProjectFormStep6.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep6.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep6.vue?vue&type=style&index=0&id=4d7a7ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7a7ac8"]])

export default __exports__